export const leaderboardConstants = {
  GOLD_MEDAL: "GOLD_MEDAL",
  SILVER_MEDAL: "SILVER_MEDAL",
  BRONZE_MEDAL: "BRONZE_MEDAL",
  GET_RANKING: "GET_RANKING",
  GET_COMPETITION_RANKING: "GET_COMPETITION_RANKING",
  LEADERBOARD_BOAT_CLASSES: "LEADERBOARD_BOAT_CLASSES",
  LEADERBOARD_DATA_NULL: "LEADERBOARD_DATA_NULL"
};

export const youthRadioConstants = {
  OVERALL: "OVERALL",
  YOUTH_ONLY: "YOUTH_ONLY",
};

export const partitionFilterConstants = {
  ParticipantAge: "ParticipantAge",
  GenderBoatClassId: "GenderBoatClassId",
};
